import React from "react";
import { formatInt, formatPct, formatSignedInt, deltaColor } from "./formatters";

interface KpiCardsProps {
  totalA: number;
  totalB: number;
  pctChange: number | null;
  labelA?: string;
  labelB?: string;
}

const card: React.CSSProperties = {
  background: "#f5f1ec",
  border: "1px solid #e7dfd4",
  borderRadius: 8,
  padding: "20px 24px",
  flex: "1 1 0",
  minWidth: 200,
};

const KpiCards: React.FC<KpiCardsProps> = ({
  totalA,
  totalB,
  pctChange,
  labelA = "Total period A",
  labelB = "Total period B",
}) => {
  const delta = totalB - totalA;
  return (
    <div style={{ display: "flex", gap: 16, flexWrap: "wrap", width: "100%", maxWidth: 1200 }}>
      <div style={card}>
        <div style={{ fontSize: 13, color: "#6b6259" }}>{labelA}</div>
        <div style={{ fontSize: 32, fontWeight: 700, marginTop: 6 }}>{formatInt(totalA)}</div>
      </div>
      <div style={card}>
        <div style={{ fontSize: 13, color: "#6b6259" }}>{labelB}</div>
        <div style={{ fontSize: 32, fontWeight: 700, marginTop: 6 }}>{formatInt(totalB)}</div>
      </div>
      <div style={card}>
        <div style={{ fontSize: 13, color: "#6b6259" }}>Overall change</div>
        <div
          style={{
            fontSize: 32,
            fontWeight: 700,
            marginTop: 6,
            color: deltaColor(delta),
          }}
        >
          {formatSignedInt(delta)} ({formatPct(pctChange)})
        </div>
      </div>
    </div>
  );
};

export default KpiCards;
